import axios from 'axios'
import {
  MessageBox,
  Toast
} from 'mint-ui';
import Loading from '@/components/Loading/index'

axios.defaults.baseURL = '';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


axios.interceptors.request.use(config => {
  Loading.open();
  return config;
}, error => {
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
axios.interceptors.response.use(response => {
  Loading.close();
  if (response.status == 200) {
    return response;
  }
  return response
}, error => {
  Loading.close();
  MessageBox.alert(error.message, "");
  return Promise.reject(error)
})

export default {
  /**
   * 课程-微信-扫描视频接口
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  scanCourseCode(params) {
    return axios.post(`/haidu/api/course/qr/getData`, params).then(res => res.data);
  },
  /**
   * 获取app市场版本信息下载地址
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAppVersion(params) {
    return axios.get(`/haidu/api/course/qr/getDownloadUrl`, {
      params: params
    }).then(res => res.data);
  },

  /**
   * 检查验证码
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkReward(params) {
    return axios.post(`/haidu/api/draw/check`, params).then(res => res.data);
  },

  /**
   * 保存奖品
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  saveReward(params) {
    return axios.post(`/haidu/api/draw/save`, params).then(res => res.data);
  },

  /**
   * 兑换奖品
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  // dhReward(params) {
  //   return axios.post(`/haidu/api/draw/getPrize`, params).then(res => res.data);
  // },

  /**
   * 获取奖品详情
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getRewardInfo(params) {
    return axios.post(`/haidu/api/draw/getPrizeDetails`, params).then(res => res.data);
  },
  /**
   * 领券活动详情
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getCouponActivityDetail(params) {
    return axios.post(`/haidu/api/h/activity/getCouponActivityDetail?activityId=` + params).then(res => res.data);
  },
  /**
   * 领券活动详情
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  verificationCode(params) {
    return axios.post(`/haidu/api/h/activity/verificationCode/sendCode`, params).then(res => res.data);
  },
  /**
   * 领券活动详情
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  verificationCodeCheckCode(params) {
    return axios.post(`/haidu/api/h/activity/verificationCode/checkCode`, params).then(res => res.data);
  },
  /**
   * 领券活动详情
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getActivityTurntableAwardDetail(params) {
    return axios.post(`/haidu/api/h/activityTurntable/getActivityTurntableAwardDetail?activityId=` + params).then(res => res.data);
  },
  /**
   * 领券活动详情
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  activityTurntableCheckChance(params) {
    return axios.post(`/haidu/api/h/activityTurntable/checkChance`, params).then(res => res.data);
  },
  /**
   * 领券活动详情
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  activityTurntableCheck(params) {
    return axios.post(`/haidu/api/h/activityTurntable/check`, params).then(res => res.data);
  },
  /**
   * 兑换奖品
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  dhReward(params) {
    return axios.post(`/haidu/api/h/activityTurntable/getPrize`, params).then(res => res.data);
  },
  getActivityTurntableDetail(params) {
    return axios.post(`/haidu/api/h/activityTurntable/getActivityTurntableDetail?activityId=` + params).then(res => res.data);
  },

  /**
   * h5推荐资讯获得详情
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  informationGetList(params) {
    return axios.post(`/haidu/api/h/information/getList?id=` + params).then(res => res.data);
  },
  checkHistory(params) {
    return axios.post(`/haidu/api/h/activityTurntable/checkHistory`, params).then(res => res.data);
  },
  login(params) {
    return axios.post(`/haidu/api/index/login`, params).then(res => res.data);
  },
  sendCode(params) {
    return axios.post(`/haidu/api/index/sendCode`, params).then(res => res.data);
  },
  getDiscoveryWelcomeCaseList(params) {
    return axios.post(`/haidu/api/h/discovery/getDiscoveryWelcomeCaseList?id=`+ params).then(res => res.data);
  },
  salonList(params) {
    return axios.post(`/haidu/api/h/salon/getList?id=`+ params).then(res => res.data);
  },
  getCooperationCaseList(params) {
    return axios.post(`/haidu/api/h/cooperation/getCooperationCaseList?id=`+ params).then(res => res.data);
  },

}



// WEBPACK FOOTER //
// ./src/service/service.js